import { useLayoutStore, type ThemeType } from '~/stores/layout'

export default defineNuxtRouteMiddleware(to => {
  const theme = (to.meta.theme as ThemeType | undefined) || 'default'

  const layoutStore = useLayoutStore()
  layoutStore.setTheme(theme)
})
